import React from "react"
import { MdCode, MdFormatBold, MdFormatItalic, MdOutlineFormatStrikethrough } from "react-icons/md"
import TextareaAutoResize from "../Form/TextareaAutoResize"
import styles from "./richTextarea.module.css"

export const insertTextAtCursor = (textarea, value = "", textToInsert = "", onChange = () => { }) => {
    if (!textarea) {
        onChange(`${value}${textToInsert}`)
        return
    }

    const startPos = textarea.selectionStart
    const endPos = textarea.selectionEnd
    const nextValue = value.slice(0, startPos) + textToInsert + value.slice(endPos)
    const result = onChange(nextValue)
    if (result === false) return

    setTimeout(() => {
        textarea.focus()
        textarea.selectionStart = startPos + textToInsert.length
        textarea.selectionEnd = startPos + textToInsert.length
    }, 10)
}

export const applyTextFormatAtCursor = (textarea, value = "", onChange = () => { }, startMarker, endMarker = startMarker) => {
    if (!textarea) return

    const startPos = textarea.selectionStart
    const endPos = textarea.selectionEnd
    const selectedText = value.slice(startPos, endPos)
    const before = value.slice(0, startPos)
    const after = value.slice(endPos)

    let nextValue
    let nextStart
    let nextEnd

    if (selectedText && selectedText.startsWith(startMarker) && selectedText.endsWith(endMarker)) {
        const unwrappedText = selectedText.slice(startMarker.length, selectedText.length - endMarker.length)
        nextValue = before + unwrappedText + after
        nextStart = startPos
        nextEnd = startPos + unwrappedText.length
    } else if (selectedText && before.endsWith(startMarker) && after.startsWith(endMarker)) {
        nextValue = before.slice(0, -startMarker.length) + selectedText + after.slice(endMarker.length)
        nextStart = startPos - startMarker.length
        nextEnd = nextStart + selectedText.length
    } else {
        nextValue = before + startMarker + selectedText + endMarker + after
        nextStart = startPos + startMarker.length
        nextEnd = nextStart + selectedText.length
    }

    const result = onChange(nextValue)
    if (result === false) return

    setTimeout(() => {
        textarea.focus()
        textarea.selectionStart = nextStart
        textarea.selectionEnd = nextEnd
    }, 10)
}

const RichTextarea = ({
    value = "",
    onChange = () => { },
    textareaRef,
    placeholder = "Escreva sua mensagem...",
    onKeyDown = () => { },
    disabled = false,
    autoFocus = false,
    minRows = 1,
    maxRows = 5,
    className = "",
    textareaProps = {},
    toolbarRef,
    toolbarActions = null,
}) => {
    const handleFormat = (startMarker, endMarker = startMarker) => {
        applyTextFormatAtCursor(textareaRef?.current, value, onChange, startMarker, endMarker)
    }

    const { style: textareaStyle = {}, ...restTextareaProps } = textareaProps

    return (
        <div className={`${styles.richTextarea} ${className}`}>
            <div className={styles.formatToolbar} ref={toolbarRef}>
                <button type="button" title="Negrito" onMouseDown={(e) => e.preventDefault()} onClick={() => handleFormat("*")} disabled={disabled}>
                    <MdFormatBold />
                </button>
                <button type="button" title="Itálico" onMouseDown={(e) => e.preventDefault()} onClick={() => handleFormat("_")} disabled={disabled}>
                    <MdFormatItalic />
                </button>
                <button type="button" title="Tachado" onMouseDown={(e) => e.preventDefault()} onClick={() => handleFormat("~")} disabled={disabled}>
                    <MdOutlineFormatStrikethrough />
                </button>
                <button type="button" title="Monoespaçado" onMouseDown={(e) => e.preventDefault()} onClick={() => handleFormat("```")} disabled={disabled}>
                    <MdCode />
                </button>
                {toolbarActions}
            </div>

            <TextareaAutoResize
                elementRef={textareaRef}
                placeholder={placeholder}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                onKeyDown={onKeyDown}
                disabled={disabled}
                style={{
                    resize: "none",
                    border: "none",
                    padding: "0.45em 0.35em",
                    ...textareaStyle,
                }}
                minRows={minRows}
                maxRows={maxRows}
                autoFocus={autoFocus}
                {...restTextareaProps}
            />
        </div>
    )
}

export default RichTextarea
